import React from "react";

const GiftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M15.1 3.21668C11.95 3.20002 8.88333 6.23335 10.2833 10H5C4.11594 10 3.2681 10.3512 2.64297 10.9763C2.01785 11.6014 1.66666 12.4493 1.66666 13.3333V16.6667C1.66666 17.1087 1.84226 17.5326 2.15482 17.8452C2.46738 18.1578 2.8913 18.3333 3.33333 18.3333H18.3333V13.3333H21.6667V18.3333H36.6667C37.1087 18.3333 37.5326 18.1578 37.8452 17.8452C38.1577 17.5326 38.3333 17.1087 38.3333 16.6667V13.3333C38.3333 12.4493 37.9821 11.6014 37.357 10.9763C36.7319 10.3512 35.884 10 35 10H29.7167C31.6667 4.55002 24.3333 0.700016 20.95 5.40002L20 6.66668L19.05 5.36668C18 3.88335 16.55 3.23335 15.1 3.21668ZM15 6.66668C16.4833 6.66668 17.2333 8.46668 16.1833 9.51668C15.1333 10.5667 13.3333 9.81668 13.3333 8.33335C13.3333 7.89132 13.5089 7.4674 13.8215 7.15484C14.134 6.84228 14.558 6.66668 15 6.66668ZM25 6.66668C26.4833 6.66668 27.2333 8.46668 26.1833 9.51668C25.1333 10.5667 23.3333 9.81668 23.3333 8.33335C23.3333 7.89132 23.5089 7.4674 23.8215 7.15484C24.134 6.84228 24.558 6.66668 25 6.66668ZM3.33333 20V33.3333C3.33333 34.2174 3.68452 35.0653 4.30964 35.6904C4.93476 36.3155 5.78261 36.6667 6.66666 36.6667H33.3333C34.2174 36.6667 35.0652 36.3155 35.6903 35.6904C36.3155 35.0653 36.6667 34.2174 36.6667 33.3333V20H21.6667V33.3333H18.3333V20H3.33333Z"
        fill="#14141E"
      />
    </svg>
  );
};

export default GiftIcon;
